// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"300c06ac","213":"3d463b22","455":"4104d14c","879":"ad45e595"}[chunkId] + ".chunk.js";
};